import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { useState, ChangeEvent, useCallback } from 'react';
import { useHelpModalState } from 'react-commons';
import { useGlobalState } from '../../../state/persistence';
import { useStyles } from '../../Shared';
import { IntegratedPartnerTypeEnum } from '../../../types';
import { useForm } from 'react-hook-form';

const useDelivery = (nextUrl: Array<string>) => {
  const { t } = useTranslation('delivery');
  const history = useHistory();
  const { dispatchQuestion, appStore, question } = useGlobalState();
  const { toggleHelpModal } = useHelpModalState();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: 'onBlur' });

  const getNextUrl = (): string => {
    const [legalInsuranceUrl, packageUrl, unionUrl] = nextUrl;
    if (appStore.partner) {
      if (
        appStore.partner.partnerType !== IntegratedPartnerTypeEnum.BROKER &&
        !appStore.partner.options?.includes('union')
      ) {
        return packageUrl;
      }

      if (appStore.partner.options?.includes('union')) {
        return unionUrl;
      }
    }

    return legalInsuranceUrl;
  };

  const goToNextPage = (): void => {
    history.push(getNextUrl());
  };

  const onSubmit = useCallback(
    (data: { deliveryDate?: string }) => {
      dispatchQuestion('deliverAt', data.deliveryDate);
      goToNextPage();
    },
    [goToNextPage, dispatchQuestion],
  );

  const onSkip = () => {
    goToNextPage();
  };

  return {
    classes: useStyles(),
    t,
    handleSubmit: handleSubmit(onSubmit),
    register,
    errors,
    onSkip,
    toggleHelpModal,
    defaultDeliveryDate: question.deliverAt || new Date().toISOString().split('T')[0],
  };
};

export default useDelivery;
